import React, { useEffect, useState } from 'react';
import { Box, Breadcrumbs, Grid, IconButton, Link, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { MdiIcon, useSnackbar, WaitDialog } from '@components';
import { mdiAttachment, mdiPencil, mdiPlus } from '@mdi/js';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useModal } from 'mui-modal-provider';
import DialogInteracao from '../../components/add-interacao';
import DialogContacto from '../../components/select-contacto';
const PropostasDetails = ({ $state, CrmService }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [interacoes, setInteracoes] = useState([]);
    const [primavera, setPrimavera] = useState({
        linhas: []
    });
    const { showModal } = useModal();
    const { showSnackbar } = useSnackbar();
    const getEstadoLinha = (linha) => {
        if (!linha.artigo)
            return '';
        if (linha.estado.estadotrans === 'T') {
            return 'Adjudicada';
        }
        else {
            if (linha.estado.fechado === true) {
                return 'Não Adjudicada';
            }
            return 'Pendente';
        }
    };
    const getOI = (linha) => {
        if (!linha.artigo)
            return '';
        if (linha.estado.estadotrans === 'T') {
            if (linha.transformacao) {
                return linha.transformacao.linha.cabecDoc.documento;
            }
        }
        else {
            if (linha.estado.fechado === true) {
                return '';
            }
            return '';
        }
    };
    const tableLinhasPrimavera = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enableTopToolbar: false,
        enablePagination: false,
        enableSorting: false,
        enableBottomToolbar: false, //hide the bottom toolbar as well if you want
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Nenhuma linha encontrada!'
        },
        columns: [
            {
                accessorKey: 'artigo',
                header: 'Artigo',
                size: 50
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 200
            },
            {
                accessorKey: 'quantidade',
                header: 'Qtd.',
                size: 30,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue.toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '-')
            },
            {
                accessorKey: 'unidade',
                header: 'Unidade',
                size: 80,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue : '-')
            },
            {
                accessorKey: 'precunit',
                header: 'Preço Unitário',
                size: 80,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue.toLocaleString('pt-PT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '-')
            },
            {
                accessorKey: 'fechado',
                header: 'Estado?',
                size: 60,
                Cell: ({ row }) => getEstadoLinha(row.original)
            },
            {
                accessorKey: 'fechado2',
                header: 'OI',
                size: 60,
                Cell: ({ row }) => getOI(row.original)
            },
            {
                accessorKey: 'totaliva',
                header: 'IVA',
                size: 80,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue.toLocaleString('pt-PT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '-')
            },
            {
                accessorKey: 'totaliliquido',
                header: 'Total Linha',
                size: 80,
                Cell: ({ row }) => (row.original.totaliliquido ? (row.original.totaliliquido + row.original.totaliva).toLocaleString('pt-PT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '-')
            }
        ],
        data: loading ? [] : primavera.linhas,
        enableRowActions: false,
        positionActionsColumn: 'last'
    });
    const tableInteracao = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enableTopToolbar: false,
        enablePagination: false,
        enableSorting: false,
        enableBottomToolbar: false, //hide the bottom toolbar as well if you want
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Nenhuma interação encontrada!'
        },
        columns: [
            {
                accessorKey: 'dataInteracao',
                header: 'Data Interação',
                size: 100,
                Cell: ({ renderedCellValue }) => moment(renderedCellValue.toString()).format('DD/MM/YYYY HH:mm')
            },
            {
                accessorKey: 'dataProximaInteracao',
                header: 'Próxima Interação',
                size: 100,
                Cell: ({ renderedCellValue }) => {
                    if (!renderedCellValue)
                        return '-';
                    return moment(renderedCellValue.toString()).format('DD/MM/YYYY HH:mm');
                }
            },
            {
                accessorKey: 'funcionarioId',
                header: 'Utilizador',
                size: 150,
                Cell: ({ row }) => row.original.Funcionario.name
            },
            {
                accessorKey: 'contactoId',
                header: 'Contacto',
                size: 150,
                Cell: ({ row }) => row.original.CoreContacto.nome
            },
            {
                accessorKey: 'tipo',
                header: 'Tipo',
                size: 100
            },
            {
                accessorKey: 'objetivos',
                header: 'Objetivos',
                size: 150
            },
            {
                accessorKey: 'anexo',
                header: 'Anexo',
                size: 150,
                Cell: ({ row }) => {
                    if (row.original.anexo) {
                        return (<Link underline='hover' onClick={() => window.open(`/api/Upload/crm/download/${row.original.anexo}`, '_blank')} color='text.primary' aria-current='page'>
                <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
                  <MdiIcon path={mdiAttachment}/>
                  {row.original.anexo}
                </Stack>
              </Link>);
                    }
                    return '-';
                }
            },
            {
                accessorKey: 'observacoes',
                header: 'Observações'
            }
        ],
        data: loading ? [] : interacoes,
        enableRowActions: false,
        positionActionsColumn: 'last'
    });
    const fetchData = async () => {
        const aux = await CrmService.getProposta($state.params.id);
        setData(aux);
        const auxI = await CrmService.getInteracoesForProposta($state.params.id);
        setInteracoes(auxI);
        fetchLinhas(aux);
        setLoading(false);
    };
    const translateEstado = () => {
        if (!primavera || !primavera.estado)
            return '';
        if (primavera.estado.fechado === true)
            return 'Fechada';
        if (primavera.estado.anulado === true)
            return 'Anulada';
        switch (primavera.estado.estado) {
            case 'G':
                return 'Em Apreciação';
            case 'P':
                return 'Pendente';
            case 'S':
                return 'Substituída';
            case 'R':
                return 'Rejeitada';
            case 'T':
                return 'Transformada';
            default:
                return '';
        }
    };
    const fetchLinhas = async (_) => {
        const l = await CrmService.getLinhasProposta(_.refPropostaPrimavera);
        setPrimavera(l);
    };
    useEffect(() => {
        if (loading) {
            fetchData();
        }
    }, [loading]);
    return (<Box>
      <Box sx={{ mt: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography>CRM</Typography>
          <Typography>Propostas</Typography>
          <Typography>Detalhes</Typography>
        </Breadcrumbs>
      </Box>

      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12} md={9}>
          <Typography variant='caption'>Cliente</Typography>
          <Typography>{loading ? <Skeleton sx={{ width: 'calc(100% - 16px)' }}/> : data?.CoreCliente?.nome}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Ref. Cliente</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : data?.refClientePrimavera}</Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Número Documento</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : data?.refPropostaPrimavera}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant='caption'>Estado Proposta</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : `${translateEstado()}`}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Data</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : moment(data?.data).format('DD/MM/YYYY HH:mm')}</Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Total Linhas</Typography>
          <Typography>
            {loading ? (<Skeleton width={200}/>) : data?.preco ? (data?.preco.toLocaleString('pt-PT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })) : ('-')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>IVA</Typography>
          <Typography>
            {loading ? (<Skeleton width={200}/>) : data?.iva ? (data?.iva.toLocaleString('pt-PT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })) : ('-')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Desconto (%)</Typography>
          <Typography>
            {loading ? (<Skeleton width={200}/>) : data?.desconto ? (data.desconto.toLocaleString('pt-PT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })) : ('-')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Total</Typography>
          <Typography>
            {loading ? (<Skeleton width={200}/>) : data?.precoTotal ? (data?.precoTotal.toLocaleString('pt-PT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })) : ('-')}
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12} md={12}>
          <Typography variant='caption'>Contacto Associado</Typography>
          {loading ? (<Skeleton sx={{ width: 'calc(100% - 16px)' }}/>) : (<Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
              <Typography>{data?.CoreContacto?.nome}</Typography>
              <Tooltip title='Alterar contacto associado'>
                <IconButton onClick={async () => {
                const wait = showModal(WaitDialog, {
                    title: 'Por favor aguarde'
                });
                const cont = await CrmService.getContactosForCliente(data.clienteId);
                showModal(DialogContacto, {
                    contactos: cont,
                    initial: {
                        contactoId: data?.contactoId
                    },
                    maxWidth: 'lg',
                    fullWidth: true,
                    onClose: async (_) => {
                        if (!_) {
                            return;
                        }
                        try {
                            await CrmService.patchProposta($state.params.id, _);
                            fetchData();
                            showSnackbar('Contacto associado alterado!');
                        }
                        catch (e) {
                            showSnackbar('Ocorreu um erro ao alterar contacto associado');
                        }
                    }
                });
                wait.destroy();
            }}>
                  <MdiIcon path={mdiPencil}/>
                </IconButton>
              </Tooltip>
            </Stack>)}
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>E-mail</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : (data?.CoreContacto?.email ?? '-')}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Telefone</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : (data?.CoreContacto?.contactoTelefonico ?? '-')}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Telemóvel</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : (data?.CoreContacto?.contactoTelemovel ?? '-')}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='caption'>Cargo</Typography>
          <Typography>{loading ? <Skeleton width={200}/> : (data?.CoreContacto?.cargo ?? 'Desconhecido')}</Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
            <Typography variant='h6'>Linhas da Proposta</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <MaterialReactTable table={tableLinhasPrimavera}/>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
            <Typography variant='h6'>Interações</Typography>
            <Tooltip title='Adicionar interação'>
              <IconButton onClick={async () => {
            const wait = showModal(WaitDialog, {
                title: 'Por favor aguarde'
            });
            const cont = await CrmService.getContactosForCliente(data?.clienteId);
            wait.destroy();
            showModal(DialogInteracao, {
                service: CrmService,
                contactos: cont,
                maxWidth: 'lg',
                fullWidth: true,
                onClose: async (_) => {
                    if (_) {
                        try {
                            await CrmService.createInteracao({
                                coreClienteId: data.clienteId,
                                propostaId: data.id,
                                ..._
                            });
                            fetchData();
                            showSnackbar('Interação adicionada com sucesso!');
                        }
                        catch (e) {
                            showSnackbar('Ocorreu um erro ao adicionar interação');
                        }
                    }
                },
                initial: {
                    coreContactoId: data?.contactoId,
                    tipo: '',
                    objetivos: '',
                    anexo: '',
                    observacoes: ''
                }
            });
        }}>
                <MdiIcon path={mdiPlus}></MdiIcon>
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <MaterialReactTable table={tableInteracao}/>
        </Grid>
      </Grid>
    </Box>);
};
export default PropostasDetails;
